"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MailListItemExpansion_1 = require("./components/MailListItemExpansion");
exports.MailListItemExpansion = MailListItemExpansion_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-list-view/lib/lazyIndex.js
// module id = 2579
// module chunks = 78